// import { useEffect, useMemo, useState } from "react";
// import { db } from "../../firebase";
// import {
//   collection,
//   deleteDoc,
//   doc,
//   getDocs,
//   updateDoc,
//   serverTimestamp,
// } from "firebase/firestore";
// import css from "./ProductReviewsAdmin.module.css";

// export default function ProductReviewsAdmin() {
//   const [reviews, setReviews] = useState([]);
//   const [productsMap, setProductsMap] = useState({});
//   const [search, setSearch] = useState("");
//   const [loading, setLoading] = useState(true);
//   const [savingId, setSavingId] = useState(null);

//   const fetchData = async () => {
//     setLoading(true);

//     try {
//       const [reviewsSnapshot, productsSnapshot] = await Promise.all([
//         getDocs(collection(db, "reviews")),
//         getDocs(collection(db, "product")),
//       ]);

//       const products = {};
//       productsSnapshot.docs.forEach((item) => {
//         const data = item.data();
//         const id = data.uid || item.id;

//         products[id] = {
//           id,
//           bookName: data.bookName || "Без назви",
//         };
//       });

//       const reviewsData = reviewsSnapshot.docs.map((item) => {
//         const data = item.data();

//         return {
//           id: item.id,
//           uid: data.uid || item.id,
//           productId: data.productId || "",
//           productName: data.productName || "",
//           vidguk: data.vidguk || "",
//           nameAutor: data.nameAutor || "",
//           autorPic: data.autorPic || "",
//           rating: data.rating || 0,
//           userUid: data.userUid || "",
//           visible: data.visible !== false,
//           createdAt: data.createdAt || null,
//           ...data,
//         };
//       });

//       setProductsMap(products);
//       setReviews(reviewsData);
//     } catch (error) {
//       console.error("Помилка завантаження відгуків:", error);
//       alert("Не вдалося завантажити відгуки");
//     } finally {
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     fetchData();
//   }, []);

//   const filteredReviews = useMemo(() => {
//     const normalizedSearch = search.trim().toLowerCase();

//     if (!normalizedSearch) return reviews;

//     return reviews.filter((review) => {
//       const productName =
//         productsMap[review.productId]?.bookName || review.productName || "";

//       return (
//         productName.toLowerCase().includes(normalizedSearch) ||
//         review.vidguk.toLowerCase().includes(normalizedSearch) ||
//         review.nameAutor.toLowerCase().includes(normalizedSearch) ||
//         review.userUid.toLowerCase().includes(normalizedSearch)
//       );
//     });
//   }, [reviews, productsMap, search]);

//   const updateLocalReview = (reviewId, field, value) => {
//     setReviews((prev) =>
//       prev.map((review) =>
//         review.id === reviewId ? { ...review, [field]: value } : review,
//       ),
//     );
//   };

//   const handleSaveReview = async (review) => {
//     setSavingId(review.id);

//     try {
//       const reviewRef = doc(db, "reviews", review.id);

//       await updateDoc(reviewRef, {
//         vidguk: review.vidguk,
//         nameAutor: review.nameAutor,
//         rating: Number(review.rating) || 0,
//         visible: review.visible !== false,
//         updatedAt: serverTimestamp(),
//       });

//       alert("Відгук збережено");
//     } catch (error) {
//       console.error("Помилка збереження відгуку:", error);
//       alert("Не вдалося зберегти відгук");
//     } finally {
//       setSavingId(null);
//     }
//   };

//   const handleToggleVisible = async (review) => {
//     const nextVisible = !review.visible;

//     updateLocalReview(review.id, "visible", nextVisible);

//     try {
//       const reviewRef = doc(db, "reviews", review.id);

//       await updateDoc(reviewRef, {
//         visible: nextVisible,
//         updatedAt: serverTimestamp(),
//       });
//     } catch (error) {
//       console.error("Помилка зміни видимості:", error);
//       updateLocalReview(review.id, "visible", review.visible);
//       alert("Не вдалося змінити видимість");
//     }
//   };

//   const handleDeleteReview = async (reviewId) => {
//     const confirmDelete = window.confirm(
//       "Видалити цей відгук? Дію не можна буде скасувати.",
//     );

//     if (!confirmDelete) return;

//     try {
//       await deleteDoc(doc(db, "reviews", reviewId));

//       setReviews((prev) => prev.filter((review) => review.id !== reviewId));
//     } catch (error) {
//       console.error("Помилка видалення відгуку:", error);
//       alert("Не вдалося видалити відгук");
//     }
//   };

//   const formatDate = (value) => {
//     if (!value) return "—";

//     if (value.toDate) {
//       return value.toDate().toLocaleDateString("uk-UA");
//     }

//     return "—";
//   };

//   return (
//     <div className={css.wrap}>
//       <div className={css.header}>
//         <div>
//           <h2>Відгуки товарів</h2>
//           <p>
//             Керування відгуками, які користувачі залишають у картках товарів.
//           </p>
//         </div>

//         <button type="button" onClick={fetchData} className={css.reloadButton}>
//           Оновити
//         </button>
//       </div>

//       <div className={css.toolbar}>
//         <input
//           type="text"
//           value={search}
//           onChange={(e) => setSearch(e.target.value)}
//           placeholder="Пошук по товару, автору або тексту відгуку"
//           className={css.searchInput}
//         />
//       </div>

//       {loading ? (
//         <p>Завантаження...</p>
//       ) : filteredReviews.length === 0 ? (
//         <p>Відгуків не знайдено.</p>
//       ) : (
//         <div className={css.list}>
//           {filteredReviews.map((review) => {
//             const productName =
//               productsMap[review.productId]?.bookName ||
//               review.productName ||
//               "Товар не знайдено";

//             return (
//               <div key={review.id} className={css.card}>
//                 <div className={css.cardTop}>
//                   <div>
//                     <h3>{productName}</h3>
//                     <p className={css.meta}>
//                       ID товару: {review.productId || "—"}
//                     </p>
//                     <p className={css.meta}>
//                       ID користувача: {review.userUid || "—"}
//                     </p>
//                     <p className={css.meta}>
//                       Дата: {formatDate(review.createdAt)}
//                     </p>
//                   </div>

//                   <label className={css.visibleLabel}>
//                     <input
//                       type="checkbox"
//                       checked={review.visible !== false}
//                       onChange={() => handleToggleVisible(review)}
//                     />
//                     Показувати на сайті
//                   </label>
//                 </div>

//                 <div className={css.formGrid}>
//                   <label>
//                     Автор
//                     <input
//                       type="text"
//                       value={review.nameAutor}
//                       onChange={(e) =>
//                         updateLocalReview(
//                           review.id,
//                           "nameAutor",
//                           e.target.value,
//                         )
//                       }
//                     />
//                   </label>

//                   <label>
//                     Рейтинг
//                     <select
//                       value={review.rating}
//                       onChange={(e) =>
//                         updateLocalReview(review.id, "rating", e.target.value)
//                       }
//                     >
//                       <option value="0">0</option>
//                       <option value="1">1</option>
//                       <option value="2">2</option>
//                       <option value="3">3</option>
//                       <option value="4">4</option>
//                       <option value="5">5</option>
//                     </select>
//                   </label>
//                 </div>

//                 <label className={css.textareaLabel}>
//                   Текст відгуку
//                   <textarea
//                     value={review.vidguk}
//                     onChange={(e) =>
//                       updateLocalReview(review.id, "vidguk", e.target.value)
//                     }
//                   />
//                 </label>

//                 <div className={css.actions}>
//                   <button
//                     type="button"
//                     onClick={() => handleSaveReview(review)}
//                     disabled={savingId === review.id}
//                     className={css.saveButton}
//                   >
//                     {savingId === review.id ? "Збереження..." : "Зберегти"}
//                   </button>

//                   <button
//                     type="button"
//                     onClick={() => handleDeleteReview(review.id)}
//                     className={css.deleteButton}
//                   >
//                     Видалити
//                   </button>
//                 </div>
//               </div>
//             );
//           })}
//         </div>
//       )}
//     </div>
//   );
// }
import { useEffect, useMemo, useState } from "react";
import { db } from "../../firebase";
import {
  collection,
  deleteDoc,
  doc,
  getDocs,
  deleteField,
  updateDoc,
  serverTimestamp,
} from "firebase/firestore";
import css from "./ProductReviewsAdmin.module.css";

export default function ProductReviewsAdmin() {
  const [reviews, setReviews] = useState([]);
  const [productsMap, setProductsMap] = useState({});
  const [search, setSearch] = useState("");
  const [loading, setLoading] = useState(true);
  const [savingId, setSavingId] = useState(null);
  const [savingReplyId, setSavingReplyId] = useState(null);
  const [deletingReplyId, setDeletingReplyId] = useState(null);
  const fetchData = async () => {
    setLoading(true);

    try {
      const [reviewsSnapshot, productsSnapshot] = await Promise.all([
        getDocs(collection(db, "reviews")),
        getDocs(collection(db, "product")),
      ]);

      const products = {};
      productsSnapshot.docs.forEach((item) => {
        const data = item.data();
        const id = data.uid || item.id;

        products[id] = {
          id,
          bookName: data.bookName || "Без назви",
        };
      });

      const reviewsData = reviewsSnapshot.docs.map((item) => {
        const data = item.data();

        return {
          id: item.id,
          ...data,

          uid: data.uid || item.id,
          productId: data.productId || "",
          productName: data.productName || "",
          vidguk: data.vidguk || "",
          nameAutor: data.nameAutor || "",
          autorPic: data.autorPic || "",
          rating: Number(data.rating) || 0,
          userUid: data.userUid || "",
          visible: data.visible !== false,
          createdAt: data.createdAt || null,

          adminReply: data.adminReply || "",
          adminReplyAuthor: data.adminReplyAuthor || "Адміністрація магазину",
          adminReplyCreatedAt: data.adminReplyCreatedAt || null,
          adminReplyUpdatedAt: data.adminReplyUpdatedAt || null,
        };
      });

      setProductsMap(products);
      setReviews(reviewsData);
    } catch (error) {
      console.error("Помилка завантаження відгуків:", error);
      alert("Не вдалося завантажити відгуки");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  const filteredReviews = useMemo(() => {
    const normalizedSearch = search.trim().toLowerCase();

    if (!normalizedSearch) return reviews;

    return reviews.filter((review) => {
      const productName =
        productsMap[review.productId]?.bookName || review.productName || "";

      return (
        productName.toLowerCase().includes(normalizedSearch) ||
        review.vidguk.toLowerCase().includes(normalizedSearch) ||
        review.nameAutor.toLowerCase().includes(normalizedSearch) ||
        review.userUid.toLowerCase().includes(normalizedSearch)
      );
    });
  }, [reviews, productsMap, search]);

  const updateLocalReview = (reviewId, field, value) => {
    setReviews((prev) =>
      prev.map((review) =>
        review.id === reviewId ? { ...review, [field]: value } : review,
      ),
    );
  };

  const handleSaveReview = async (review) => {
    setSavingId(review.id);

    try {
      const reviewRef = doc(db, "reviews", review.id);

      await updateDoc(reviewRef, {
        vidguk: review.vidguk,
        nameAutor: review.nameAutor,
        rating: Number(review.rating) || 0,
        visible: review.visible !== false,
        updatedAt: serverTimestamp(),
      });

      alert("Відгук збережено");
    } catch (error) {
      console.error("Помилка збереження відгуку:", error);
      alert("Не вдалося зберегти відгук");
    } finally {
      setSavingId(null);
    }
  };

  const handleToggleVisible = async (review) => {
    const nextVisible = !review.visible;

    updateLocalReview(review.id, "visible", nextVisible);

    try {
      const reviewRef = doc(db, "reviews", review.id);

      await updateDoc(reviewRef, {
        visible: nextVisible,
        updatedAt: serverTimestamp(),
      });
    } catch (error) {
      console.error("Помилка зміни видимості:", error);
      updateLocalReview(review.id, "visible", review.visible);
      alert("Не вдалося змінити видимість");
    }
  };
  const handleSaveReply = async (review) => {
    const replyText = String(review.adminReply || "").trim();
    const replyAuthor =
      String(review.adminReplyAuthor || "").trim() || "Адміністрація магазину";

    if (!replyText) {
      alert("Введіть текст відповіді на відгук");
      return;
    }

    setSavingReplyId(review.id);

    try {
      const reviewRef = doc(db, "reviews", review.id);

      const updateData = {
        adminReply: replyText,
        adminReplyAuthor: replyAuthor,
        adminReplyUpdatedAt: serverTimestamp(),
        updatedAt: serverTimestamp(),
      };

      // Дату створення встановлюємо лише під час першої відповіді
      if (!review.adminReplyCreatedAt) {
        updateData.adminReplyCreatedAt = serverTimestamp();
      }

      await updateDoc(reviewRef, updateData);

      const localDate = new Date();

      setReviews((previousReviews) =>
        previousReviews.map((item) =>
          item.id === review.id
            ? {
                ...item,
                adminReply: replyText,
                adminReplyAuthor: replyAuthor,
                adminReplyCreatedAt: item.adminReplyCreatedAt || localDate,
                adminReplyUpdatedAt: localDate,
              }
            : item,
        ),
      );

      alert("Відповідь збережено");
    } catch (error) {
      console.error("Помилка збереження відповіді:", error);
      alert("Не вдалося зберегти відповідь");
    } finally {
      setSavingReplyId(null);
    }
  };
  const handleDeleteReply = async (review) => {
    const confirmDelete = window.confirm(
      "Видалити відповідь адміністрації на цей відгук?",
    );

    if (!confirmDelete) return;

    setDeletingReplyId(review.id);

    try {
      const reviewRef = doc(db, "reviews", review.id);

      await updateDoc(reviewRef, {
        adminReply: deleteField(),
        adminReplyAuthor: deleteField(),
        adminReplyCreatedAt: deleteField(),
        adminReplyUpdatedAt: deleteField(),
        updatedAt: serverTimestamp(),
      });

      setReviews((previousReviews) =>
        previousReviews.map((item) =>
          item.id === review.id
            ? {
                ...item,
                adminReply: "",
                adminReplyAuthor: "Адміністрація магазину",
                adminReplyCreatedAt: null,
                adminReplyUpdatedAt: null,
              }
            : item,
        ),
      );

      alert("Відповідь видалено");
    } catch (error) {
      console.error("Помилка видалення відповіді:", error);
      alert("Не вдалося видалити відповідь");
    } finally {
      setDeletingReplyId(null);
    }
  };
  const handleDeleteReview = async (reviewId) => {
    const confirmDelete = window.confirm(
      "Видалити цей відгук? Дію не можна буде скасувати.",
    );

    if (!confirmDelete) return;

    try {
      await deleteDoc(doc(db, "reviews", reviewId));

      setReviews((prev) => prev.filter((review) => review.id !== reviewId));
    } catch (error) {
      console.error("Помилка видалення відгуку:", error);
      alert("Не вдалося видалити відгук");
    }
  };

  const formatDate = (value) => {
    if (!value) return "—";

    try {
      if (typeof value.toDate === "function") {
        return value.toDate().toLocaleDateString("uk-UA");
      }

      if (value instanceof Date) {
        return value.toLocaleDateString("uk-UA");
      }

      if (typeof value === "string" || typeof value === "number") {
        const parsedDate = new Date(value);

        if (!Number.isNaN(parsedDate.getTime())) {
          return parsedDate.toLocaleDateString("uk-UA");
        }
      }

      return "—";
    } catch (error) {
      console.error("Помилка форматування дати:", error);
      return "—";
    }
  };

  return (
    <div className={css.wrap}>
      <div className={css.header}>
        <div>
          <h2>Відгуки товарів</h2>
          <p>
            Керування відгуками, які користувачі залишають у картках товарів.
          </p>
        </div>

        <button type="button" onClick={fetchData} className={css.reloadButton}>
          Оновити
        </button>
      </div>

      <div className={css.toolbar}>
        <input
          type="text"
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          placeholder="Пошук по товару, автору або тексту відгуку"
          className={css.searchInput}
        />
      </div>

      {loading ? (
        <p>Завантаження...</p>
      ) : filteredReviews.length === 0 ? (
        <p>Відгуків не знайдено.</p>
      ) : (
        <div className={css.list}>
          {filteredReviews.map((review) => {
            const productName =
              productsMap[review.productId]?.bookName ||
              review.productName ||
              "Товар не знайдено";

            return (
              <div key={review.id} className={css.card}>
                <div className={css.cardTop}>
                  <div>
                    <h3>{productName}</h3>
                    <p className={css.meta}>
                      ID товару: {review.productId || "—"}
                    </p>
                    <p className={css.meta}>
                      ID користувача: {review.userUid || "—"}
                    </p>
                    <p className={css.meta}>
                      Дата: {formatDate(review.createdAt)}
                    </p>
                  </div>

                  <label className={css.visibleLabel}>
                    <input
                      type="checkbox"
                      checked={review.visible !== false}
                      onChange={() => handleToggleVisible(review)}
                    />
                    Показувати на сайті
                  </label>
                </div>

                <div className={css.formGrid}>
                  <label>
                    Автор
                    <input
                      type="text"
                      value={review.nameAutor}
                      onChange={(e) =>
                        updateLocalReview(
                          review.id,
                          "nameAutor",
                          e.target.value,
                        )
                      }
                    />
                  </label>

                  <label>
                    Рейтинг
                    <select
                      value={review.rating}
                      onChange={(e) =>
                        updateLocalReview(review.id, "rating", e.target.value)
                      }
                    >
                      <option value="0">0</option>
                      <option value="1">1</option>
                      <option value="2">2</option>
                      <option value="3">3</option>
                      <option value="4">4</option>
                      <option value="5">5</option>
                    </select>
                  </label>
                </div>

                <label className={css.textareaLabel}>
                  Текст відгуку
                  <textarea
                    value={review.vidguk}
                    onChange={(e) =>
                      updateLocalReview(review.id, "vidguk", e.target.value)
                    }
                  />
                </label>
                <div className={css.replyBox}>
                  <div className={css.replyHeader}>
                    <div>
                      <h4>Відповідь на відгук</h4>

                      {review.adminReplyCreatedAt && (
                        <p>
                          Створено: {formatDate(review.adminReplyCreatedAt)}
                        </p>
                      )}
                    </div>

                    {review.adminReply?.trim() && (
                      <span className={css.replyStatus}>
                        Відповідь опублікована
                      </span>
                    )}
                  </div>

                  <label className={css.replyAuthorLabel}>
                    Підпис відповіді
                    <input
                      type="text"
                      value={review.adminReplyAuthor}
                      onChange={(e) =>
                        updateLocalReview(
                          review.id,
                          "adminReplyAuthor",
                          e.target.value,
                        )
                      }
                      placeholder="Адміністрація магазину"
                    />
                  </label>

                  <label className={css.replyTextareaLabel}>
                    Текст відповіді
                    <textarea
                      value={review.adminReply}
                      onChange={(e) =>
                        updateLocalReview(
                          review.id,
                          "adminReply",
                          e.target.value,
                        )
                      }
                      placeholder="Напишіть відповідь на відгук користувача..."
                    />
                  </label>

                  <div className={css.replyActions}>
                    <button
                      type="button"
                      onClick={() => handleSaveReply(review)}
                      disabled={savingReplyId === review.id}
                      className={css.replySaveButton}
                    >
                      {savingReplyId === review.id
                        ? "Збереження..."
                        : review.adminReplyCreatedAt
                          ? "Оновити відповідь"
                          : "Опублікувати відповідь"}
                    </button>

                    {review.adminReply?.trim() && (
                      <button
                        type="button"
                        onClick={() => handleDeleteReply(review)}
                        disabled={deletingReplyId === review.id}
                        className={css.replyDeleteButton}
                      >
                        {deletingReplyId === review.id
                          ? "Видалення..."
                          : "Видалити відповідь"}
                      </button>
                    )}
                  </div>
                </div>

                <div className={css.actions}>
                  <button
                    type="button"
                    onClick={() => handleSaveReview(review)}
                    disabled={savingId === review.id}
                    className={css.saveButton}
                  >
                    {savingId === review.id ? "Збереження..." : "Зберегти"}
                  </button>

                  <button
                    type="button"
                    onClick={() => handleDeleteReview(review.id)}
                    className={css.deleteButton}
                  >
                    Видалити
                  </button>
                </div>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}
